// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { CssBaseline, Container, backdropClasses } from '@mui/material';
// import NavBar from './components/NavBar';
// import TitleBar from './components/TitleBar';
// import { ToastContainer, toast } from 'react-toastify';
// import Watchlist from './pages/Watchlist';
// //import WebSocketComponent from './pages/WebSocketComponent';
// import Trades from './pages/Trades';
// import Portfolio from './pages/Portfolio';
// import Profile from './pages/Profile';
// import Performance from './pages/Performance';
// import BlockedScripts from './pages/BlockedScripts';
// import StockList from "./StockList";
// import { WebSocketProvider, WebSocketContext } from "./WebSocketContext";
// import NavigationNotifier from './NavigationNotifier';
// import './index.css';
// import ChangePassword from './pages/ChangePassword';
// import Login from './pages/Login';

// function App() {
//   const resource = "zerodha"; // Example resource
//   const stockIDs = [
//     // Example stock IDs or subscriptions
//     "CRUDEOILM24JULFUT",
//     "CRUDEOIL24JULFUT"
//   ];
//   const user_id = '689239';
  
//   return (
    
//     <WebSocketProvider style={{ backgroundColor:'#f8f9fa'}} user_id={user_id} resource={resource} stockIDs={stockIDs}>
//       {/* <Router> */}
//         <CssBaseline />
//         <TitleBar />
//         <Container style={{ paddingTop: '64px', paddingBottom: '64px', backgroundColor:'#f8f9fa' }}>
//           <ToastContainer />
//           <NavigationNotifier />
//           <Routes>
//             <Route path="/" element={<StockList />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/trades" element={<Trades />} />
//             <Route path="/portfolio" element={<Portfolio />} />
//             <Route path="/performance" element={<Performance />} />
//             <Route path="/blocked-scripts" element={<BlockedScripts />} />
//             <Route path="/change-password" element={<ChangePassword />} />
//             {/* <Route path="/profile" element={<Profile />} /> */}
//           </Routes>
//         </Container>
//         <NavBar />
//       {/* </Router> */}
//     </WebSocketProvider>
//   );
// }

// export default App;



// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { CssBaseline, Container } from '@mui/material';
import NavBar from './components/NavBar';
import TitleBar from './components/TitleBar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StockList from './StockList';
// ============================================
// NOTIFICATION DISPLAY - Easy to disable
// ============================================
// DISABLED FOR DEPLOYMENT - Uncomment when ready to test
// To disable: Comment out the import below
// import NotificationDisplay from './components/NotificationDisplay';
import Trades from './pages/Trades';
import Portfolio from './pages/Portfolio';
import Performance from './pages/Performance';
import Deposit from './pages/Deposit';
import Withdrawal from './pages/Withdrawal';
import BlockedScripts from './pages/BlockedScripts';
import ChangePassword from './pages/ChangePassword';
import Login from './pages/Login';
import Register from './pages/Register';
import LoginNew from './pages/LoginNew';
//import { AuthProvider, useAuth } from './contexts/AuthContext';
import './index.css';
import NavigationNotifier from './NavigationNotifier';
import { WebSocketProvider } from './WebSocketContext';
import ProtectedRoute from './ProtectedRoute';
import { Outlet } from 'react-router-dom';
import { getToken, storeToken, removeToken } from './utils/auth'; // Adjust path as needed
import AddScript from './pages/AddScript';
import Ledger from './pages/Ledger';
import MLMDashboard from './pages/MLMDashboard';
import MLMPortfolio from './pages/MLMPortfolio';
import MLMPerformance from './pages/MLMPerformance';
import BottomTime from './components/BottomTime';
import RejectionLogs from './pages/RejectionLogs';
import { Helmet } from 'react-helmet';
import { buildCspConnectSrc } from './config';
import AutomationBlocked from './components/AutomationBlocked';
import { isAutomationBlockPersisted } from './utils/automationGuard';
import SessionExpiredDialog from './components/SessionExpiredDialog';
import { canUseDeposit, canUseWithdraw } from './utils/depositWithdrawAccess';

const DepositRoute = ({ children }) => {
  if (!canUseDeposit()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const WithdrawRoute = ({ children }) => {
  const clientId = Number(localStorage.getItem('userId'));
  if (!canUseWithdraw(null, clientId)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const Layout = () => {
  //const { isAuthenticated } = useAuth();
  const resource = "zerodha";
  const stockIDs = ["CRUDEOILM24JULFUT", "CRUDEOIL24JULFUT"];
  //const user_id = '689239';
  const user_id = Number(localStorage.getItem('userId'));
  const location = useLocation();
  const token = localStorage.getItem('authToken');
  
  // Hide TitleBar and NavBar on change-password page
  const hideNavigation = location.pathname === '/change-password';

  return token ? (
    <WebSocketProvider user_id={user_id} resource={resource} stockIDs={stockIDs}>
      {/* ============================================ */}
      {/* NOTIFICATION DISPLAY - Easy to disable */}
      {/* DISABLED FOR DEPLOYMENT - Uncomment when ready to test */}
      {/* To disable: Comment out the line below */}
      {/* <NotificationDisplay /> */}
      {/* ============================================ */}
      {!hideNavigation && <TitleBar />}
      <Container
        className={`app-main-container${hideNavigation ? ' app-main-container--flush' : ''}`}
        style={{ backgroundColor: '#f8f9fa' }}
      >
        <Outlet />
      </Container>
      {!hideNavigation && <NavBar />}
    </WebSocketProvider>
  ) : (
    <Navigate
      to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
      replace
    />
  );
};

function App() {
  if (isAutomationBlockPersisted()) {
    return <AutomationBlocked />;
  }

  return (
    <>
      <Helmet>
        <meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
        {process.env.NODE_ENV === 'production' && (
          <meta
            httpEquiv="Content-Security-Policy"
            content={[
              "default-src 'self'",
              "script-src 'self'",
              "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com",
              "font-src 'self' https://fonts.gstatic.com data:",
              "img-src 'self' data: https:",
              `connect-src ${buildCspConnectSrc()}`,
              "frame-src https://www.youtube.com",
              "object-src 'none'",
              "base-uri 'self'",
              "form-action 'self'",
            ].join('; ')}
          />
        )}
      </Helmet>
      <CssBaseline />
      <ToastContainer />
      <SessionExpiredDialog />
      <NavigationNotifier />
      {/* <Router> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route element={<Layout />}>
            <Route path="/addScript" element={<ProtectedRoute element={<AddScript />} />} />
            <Route path="/" element={<ProtectedRoute element={<StockList />} />} />
            <Route path="/trades" element={<ProtectedRoute element={<Trades />} />} />
            <Route path="/portfolio" element={<ProtectedRoute element={<Portfolio />} />} />
            <Route path="/performance" element={<ProtectedRoute element={<Performance />} />} />
            <Route path="/deposit" element={<ProtectedRoute element={<DepositRoute><Deposit /></DepositRoute>} />} />
            <Route path="/withdrawal" element={<ProtectedRoute element={<WithdrawRoute><Withdrawal /></WithdrawRoute>} />} />
            <Route path="/blocked-scripts" element={<ProtectedRoute element={<BlockedScripts />} />} />
            <Route path="/rejection-logs" element={<ProtectedRoute element={<RejectionLogs />} />} />
            <Route path="/change-password" element={<ProtectedRoute element={<ChangePassword />} />} />
            <Route path="/ledger" element={<ProtectedRoute element={<Ledger />} />} />
            <Route path="/mlmdashboard" element={<ProtectedRoute element={<MLMDashboard />} />} />
            <Route path="/mlmportfolio" element={<ProtectedRoute element={<MLMPortfolio />} />} />
            <Route path="/mlmperformance" element={<ProtectedRoute element={<MLMPerformance />} />} />
          </Route>
        </Routes>
      {/* </Router> */}
    </>
  );
}

export default App;

